export default __webpack_public_path__ + "static/media/leonard-cohen-everybody-knows.72efd7f7.mp3";